// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ImportSvg from '@rsuite/icon-font/lib/network/Import';
var Import = createSvgIcon({
  as: ImportSvg,
  ariaLabel: 'import',
  category: 'network',
  displayName: 'Import'
});
export default Import;